import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, MapPinIcon } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  name: string;
  location: string;
  result: string;
  delay: number;
}
function TestimonialCard({
  quote,
  name,
  location,
  result,
  delay
}: TestimonialProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay
  }} className="bg-gradient-to-br from-gray-900 to-black border border-amber-500/30 rounded-xl p-6 shadow-xl hover:shadow-amber-500/20 transition-shadow duration-300" data-id="element-200">
      <div className="flex gap-1 mb-4" data-id="element-201">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-202" />)}
      </div>
      <p className="text-gray-200 leading-relaxed mb-6 italic" data-id="element-203">"{quote}"</p>
      <div className="border-t border-gray-700 pt-4" data-id="element-204">
        <p className="font-semibold text-white mb-1" data-id="element-205">{name}</p>
        <div className="flex items-center gap-2 text-sm text-gray-400 mb-3" data-id="element-206">
          <MapPinIcon className="w-4 h-4" data-id="element-207" />
          <span data-id="element-208">{location}</span>
        </div>
        <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg px-4 py-2 inline-block" data-id="element-209">
          <span className="text-amber-400 font-bold" data-id="element-210">Resultado: {result}</span>
        </div>
      </div>
    </motion.div>;
}
export function TestimonialsSection() {
  return <section className="py-20 px-4 bg-black/20" data-id="element-211">
      <div className="max-w-6xl mx-auto" data-id="element-212">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-213">
          Lo Que Están Diciendo Nuestros Estudiantes
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-214">
          <TestimonialCard quote="Pasé de trabajar en un Amazon Warehouse 60 horas a la semana a ganar mis primeros $1,200 haciendo logos con IA desde mi mesa del comedor. ¡Siento que por fin soy libre!" name="Mateo G." location="Miami, FL" result="$1,200/mes extra" delay={0} data-id="element-215" />
          <TestimonialCard quote="No hablaba bien inglés, por eso me daba miedo ser freelance. Con el hack de IA que enseña este libro, ahora hablo con clientes en Upwork perfectamente y ya tengo 3 clientes fijos. ¡Gracias!" name="Elena R." location="New Jersey" result="3 clientes en 14 días" delay={0.2} data-id="element-216" />
        </div>
      </div>
    </section>;
}